module.exports = __webpack_public_path__ + "static/img/lifestyle_08.0e094619.jpg";